import { render, staticRenderFns } from "./deleteBusinessOpportunity.vue?vue&type=template&id=2e95a742&scoped=true"
import script from "./deleteBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./deleteBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./deleteBusinessOpportunity.vue?vue&type=style&index=0&id=2e95a742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e95a742",
  null
  
)

export default component.exports